import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowPathUp"><Path d="M15.5 21.5H8.5V10.5H4.5L12 1.75L19.5 10.5L15.5 10.5V21.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowPathUp;
